import { HttpClient, HttpParams } from '@angular/common/http';
import { inject } from '@angular/core';
import { BatchingRules } from '@types-lib';
import { ENVIRONMENT, PIMSEnvironment } from 'environments';

export class BatchingRulesEndpoints {
  private env = inject<PIMSEnvironment>(ENVIRONMENT);
  private http = inject(HttpClient);

  // Get Rules
  get(req: BatchingRules.BatchingRulesGetRequest = {}) {
    const params = convertRequestToParams(req);

    return this.http.get<BatchingRules.BatchingRulesGetResponse>(
      `${this.env.constants.ADMIN_API_URL}/admin/batches/rules`,
      {
        params,
        headers: { 'X-Service-Code': 'BOOTS' },
      },
    );
  }

  // Create rule
  post(body: BatchingRules.CreateBatchingRuleRequest) {
    const url = `${this.env.constants.ADMIN_API_URL}/admin/batches/rules`;
    return this.http.post<BatchingRules.BatchingRule>(url, body);
  }
}

const convertRequestToParams = (request: BatchingRules.BatchingRulesGetRequest): HttpParams => {
  let params = new HttpParams();

  // Destructure the nested groups
  const { pagination, filterParams, searchParams, sortParams, debug } = request;

  // Helper to merge objects into the params
  const addParams = (obj?: object) => {
    if (!obj) return;
    Object.entries(obj).forEach(([key, value]) => {
      // Convert camelCase to snake_case
      const snakeKey = key?.replace(/[A-Z]/g, letter => `_${letter.toLowerCase()}`);
      const stringValue: string | undefined =
        value && Array.isArray(value) ? value.join(key === 'params' ? ';' : ',') : value?.toString();
      if (stringValue !== undefined && stringValue !== null && stringValue !== '') {
        params = params.set(snakeKey, stringValue as string);
      }
    });
  };

  addParams(pagination);
  addParams(filterParams);
  addParams(searchParams);
  addParams(sortParams);

  if (debug !== undefined) {
    params = params.set('debug', debug.toString());
  }

  return params;
};
